import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Apollo, gql } from 'apollo-angular';
import { BehaviorSubject, Subscription, Observable } from 'rxjs';
import { DealDispositionsService } from 'src/app/deals/deal-dispositions/deal-dispositions.service';
import { DispositionInput } from 'src/app/deals/deal-dispositions/graphql/dispositions';
import Disposition from 'src/app/interfaces/disposition';
import Organization from 'src/app/interfaces/organization';
import Project from 'src/app/interfaces/project';
import DispositionDistribution from '../../interfaces/disposition-distribution';

@Component({
    selector: 'disposition-section',
    templateUrl: './disposition-section.component.html',
    styleUrls: ['./disposition-section.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DispositionSectionComponent {
  dispositionsSub: Subscription;
  dispositions: Disposition[] = [];

  constructor(
    public dispositionsService: DealDispositionsService,
    public apollo: Apollo
  ) {}
  distributionChanged(distribution: DispositionDistribution) {
    this.dispositionsService.dispositionDistributionChanged(distribution);
  }
  ngOnInit() {
    this.dispositionsSub = this.dispositionsService.dispositions$.subscribe(
      (dispositions: Disposition[]) => {
        if (dispositions) {
          this.dispositions = dispositions;
        }
      }
    );
  }
  createDispositionDistribution(dispositionId: string) {
    this.dispositionsService.createDispositionDistribution(dispositionId);
  }
}
